import useAPI from '@/hooks/useAPI';
import PhaseTypeRepository from '@/repositories/PhaseTypeRepository';
import { QueryParams } from '@/types/query';

export const usePhaseTypes = (params: QueryParams = {}, enabled = true) => {
  const phaseTypeRepository = PhaseTypeRepository();

  return useAPI({
    queryKey: ['getPhaseTypes', params],
    queryFn: async () => {
      return await phaseTypeRepository.list(params);
    },
    enabled
  });
};

export default usePhaseTypes;
